import Swiper from 'swiper';
import Vue from 'vue';

export default function () {
  const offices = document.querySelector('.offices');

  if (offices) {
    new Vue({
      el: offices,
      delimiters: ['${', '}}'],
      components: {
      },
      data: {
        manager: window.manager,
        popupIsOpen: false,
      },
      mounted() {
        const sliderBtns = [].slice.call(this.$el.querySelectorAll('.sliderButtons__btn'));
        const sliderWrp = this.$el.querySelector('.offices__slider');

        if (sliderWrp) {
          const slides = [].slice.call(this.$el.querySelectorAll('.offices__slide'));

          if (slides && slides.length > 1) {
            new Swiper(sliderWrp, {
              slidesPerView: 'auto',
              freeMode: true,
              spaceBetween: 20,
              resistance: true,
              resistanceRatio: 0,
              navigation: {
                prevEl: sliderBtns[0],
                nextEl: sliderBtns[1],
                disabledClass: 'sliderButtons__btn--disabled',
              },
            });
          }
        }
      },
    });
  }
}



// WEBPACK FOOTER //
// ./bali-blocks/offices/offices.js